import * as React from 'react'
import styled from 'styled-components'

const bemComponentName = 'twoPanelLayout'

export const classes = {
  panel: `${bemComponentName}__panel`,
  title: `${bemComponentName}__title`,
  subtitle: `${bemComponentName}__subtitle`,
  content: `${bemComponentName}__content`,
  leftFooter: `${bemComponentName}__leftFooter`,
  // kept for any external references that may still exist
  panels: `${bemComponentName}__panels`,
  leftPanel: `${bemComponentName}__leftPanel`,
  rightPanel: `${bemComponentName}__rightPanel`,
  illustration: `${bemComponentName}__illustration`,
}

/**
 * Single-column layout for login and related flows (aligned with account-lifecycle UI).
 * Title and subtitle sit above the interactive content; illustration slot is ignored.
 */
const Title = styled.h1`
  margin: 0 0 0.5rem 0;
  font-family: 'Bower', Georgia, 'Times New Roman', serif;
  font-weight: 700;
  font-size: ${({ $titleFontSize }: { $titleFontSize?: string }): string => $titleFontSize || '28px'};
  line-height: 1.15;
  color: #0a0a0a;
`

const StyledPanel = styled.div`
  .${classes.panel} {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 2rem;
  }

  .${classes.subtitle} {
    margin: 0 0 0.75rem 0;
    font-family: 'McKinsey Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #757575;
  }

  .${classes.content} {
    display: flex;
    flex-direction: column;
    row-gap: 1.25rem;
    width: 100%;
    margin: 0 auto;
  }
`

type TwoPanelViewLayoutProps = {
  illustration?: React.ReactNode
  title?: React.ReactNode
  titleFontSize?: string
  subtitle?: React.ReactNode
  leftFooter?: React.ReactNode
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

const TwoPanelViewLayout = ({
  title,
  titleFontSize,
  subtitle,
  leftFooter,
  children,
  className,
  style,
}: TwoPanelViewLayoutProps): JSX.Element => (
  <StyledPanel className={className} style={style}>
    <div className={classes.panel}>
      {title && (
        <Title className={classes.title} $titleFontSize={titleFontSize}>
          {title}
        </Title>
      )}
      {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
      <div className={classes.content}>{children}</div>
      {leftFooter && <div className={classes.leftFooter}>{leftFooter}</div>}
    </div>
  </StyledPanel>
)

TwoPanelViewLayout.defaultProps = {
  illustration: null,
  title: null,
  titleFontSize: undefined,
  subtitle: null,
  leftFooter: null,
  className: undefined,
  style: undefined,
}

export default TwoPanelViewLayout
